import { render, staticRenderFns } from "./GoodsDeclarationForm.vue?vue&type=template&id=87ea8b30"
import script from "./GoodsDeclarationForm.vue?vue&type=script&lang=js"
export * from "./GoodsDeclarationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports